function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "179.206 196.617 28.412 28.344",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1396.456909, 1489.059814)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1577.444-1267.432c.079-.379.15-.761.238-1.138a12.454,12.454,0,0,1,1.357-3.422,12.492,12.492,0,0,1,2.064-2.66,12.663,12.663,0,0,1,2.764-2.059.268.268,0,0,1,.358.048,14.276,14.276,0,0,0,1.228.959,7.926,7.926,0,0,0,4,1.275,8.081,8.081,0,0,0,3.533-.616,7.516,7.516,0,0,0,2.405-1.564.342.342,0,0,1,.488-.067,13.776,13.776,0,0,1,2.505,1.849,12.3,12.3,0,0,1,2.063,2.511,12.326,12.326,0,0,1,1.711,4.581c.016.1.049.2.074.3v.4a1.106,1.106,0,0,1-1.165.724q-11.229-.006-22.457,0a1.11,1.11,0,0,1-1.165-.725Z",
    style: {
      fill: "rgb(153, 153, 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1589.827-1275.508a7.1,7.1,0,0,1-7.081-7.095,7.09,7.09,0,0,1,7.092-7.085,7.1,7.1,0,0,1,7.091,7.106A7.112,7.112,0,0,1,1589.827-1275.508Z",
    style: {
      fill: "rgb(153, 153, 153)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCropped);
export default __webpack_public_path__ + "static/media/account-cropped.1e281e9f0de4525fe5e6cbdaad4095e8.svg";
export { ForwardRef as ReactComponent };